import { Stack, Text } from "@chakra-ui/react";
import { Instant } from "@js-joda/core";
import React from "react";
import DocumentPaper, { DocumentReviewHeader } from "./DocumentPaper";
import type { LayoutBlock } from "./layout/documentLayout";

// HTML-template documents (non-GENERAL, or GENERAL with an HTML version): their PDF is built from
// a template, so instead of mimicking it the visible questions are listed one under the other in
// question order, headers acting as section titles (see listQuestions). `renderBlock` adds the
// same review actions as on the GENERAL preview: comment, and Edit with the same inline editors.

interface Props {
  blocks: LayoutBlock[];
  header: DocumentReviewHeader;
  submittedAt: Instant | null;
  title: string;
  renderBlock: (block: LayoutBlock) => React.ReactNode;
}

export default function DocumentQuestionList(props: Props) {
  return (
    <DocumentPaper header={props.header} submittedAt={props.submittedAt} title={props.title}>
      <Text color="gray.500" fontSize="11px" fontStyle="italic" mb="16px" textAlign="center">
        This document type prints from its own template; its questions are listed in order.
      </Text>
      {props.blocks.length === 0 ? (
        <Text color="gray.500" fontStyle="italic" textAlign="center">
          This document has no questions to show.
        </Text>
      ) : (
        <Stack spacing="20px">
          {props.blocks.map((block) => (
            <React.Fragment key={block.question.id}>{props.renderBlock(block)}</React.Fragment>
          ))}
        </Stack>
      )}
    </DocumentPaper>
  );
}
